import ScrollPane from './ScrollPane'

export default {
  name: 'scroll-pane',
  configure: function(config) {
    config.addComponent('scroll-pane', ScrollPane)
  }
}
